<template>
<el-dialog
  v-dialogDrag
  :destroy-on-close="true"
  :title="signData.formModelJsonList[1].tableComment"
  width="50%"
  :close-on-click-modal="true"
  :close-on-press-escape="true"
  top="10vh"
  @close="dialogClose"
  :append-to-body="true"
  :visible.sync="signFillUnitInfo.show">
    <avue-form ref="sign"
                :option="signData.formModelJsonList[1]"
                v-model="formInfo">
    </avue-form>
    <!-- 会签字表填写 -->
  <template slot="footer" >
      <el-button @click="signFillUnitInfo.show = false" :loading="buttonLoading" >取消</el-button>
      <el-button type="primary" @click="handleButtonConfirm" :loading="buttonLoading">确认</el-button>
  </template>
</el-dialog>
</template>

<script>
import flowUserSelect from './flowUserSelect.vue'
export default {
  data() {
    return {
      acceptUserValidator: (rule, value, callback) => {
        if (typeof value === 'string') {
          callback()
        } else {
          value && value.id ? callback() : callback(new Error(`您必须选择一项...`))
        }
      },
      buttonLoading: false,
      // 表单数据
      formInfo: {}
    }
  },
  components: { flowUserSelect },
  props: {
    'signFillUnitInfo': {
      type: Object
    },
    'signData': {
      type: Object
    }
  },
  computed: {
    // 是否为自定义选择器选人  当需要选人的时候,减签需要服务器加载数据到select进行候选
    customSelector() {
      return this.choosePerson && this.changeKey !== 'cancelAddSign'
    }
  },

  methods: {
    // 确定
    handleButtonConfirm() {
      this.$refs.sign.validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          this.$emit('signSubmit', Object.assign(this.formInfo, {
            processInstanceId: this.signData.processInstanceId,
            taskId: this.signData.taskId
          }), this.signData.formKeyList[1], () => {
            this.signFillUnitInfo.show = this.buttonLoading = false
          }, () => {
            this.buttonLoading = false
          })
        }
      })
    },
    dialogClose() {
      this.formInfo = {}
    }
  }
}
</script>
<style lang='scss'>
.concatPrimaryTheme {
  .el-dialog__body {
    padding: 0;
  }
}
</style>
